import connectPagination from "instantsearch.js/es/connectors/pagination/connectPagination.js";
import { useConnector } from "../hooks/useConnector.js";
export function usePagination(props, additionalWidgetProperties) {
  return useConnector(connectPagination, props, additionalWidgetProperties);
}